import React from 'react'
import {myAccount} from '../constants/Common'
import {Tabs} from 'antd'
import {Link} from "gatsby";

const { TabPane } = Tabs;

const SettingLeftBar = ({ activeKey, onTabChange, tabs }) => {
   tabs =  tabs || myAccount;
  return (
    <div className="tab-with-icon">
      <ul>
        <Tabs
          defaultActiveKey={tabs[Object.keys(tabs)[0]].key}
          tabPosition="left"
          activeKey={activeKey}
        >
          {Object.values(tabs).map((Dlist, index) => {
            return (
              <TabPane
                tab={
                    <Link to={`/${Dlist.key}`}>
                  <li
                    key={index}
                    className="d-flex align-items-center j-space-between"
                  >
                    <div className="tab-icon-name d-flex align-items-center">
                      <div className="tab-shape-name"> {Dlist.label}</div>
  
                    </div>
                  </li>
                    </Link>
                }
                key={Dlist.key}
              />
            )
          })}
        </Tabs>
      </ul>
    </div>
  )
}

export default SettingLeftBar
